import { appendAndReplaceQueryParams } from '@office-start/url-parser-utility';
import { appendQueryInformation } from './appendQueryInformation';
import { getFormAuthenticatedCdn } from './getFormAuthenticatedCdn';
export var getCreateFormFromTemplateLink = function (formsOptions, formId) {
    var url = getFormAuthenticatedCdn(formsOptions, false);
    var params = {
        Action: 'CreateByTemplate',
        Fragment: "FormId=".concat(formId),
    };
    url = appendAndReplaceQueryParams(url, params, true);
    return appendQueryInformation(formsOptions.componentContext, url, true);
};
//# sourceMappingURL=getCreateFormFromTemplateLink.js.map